module.exports = __webpack_public_path__ + "static/img/his-radio-bg.fabf2402.png";